// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","warning":"PagerWarning__warning--My","button":"PagerWarning__button--Cj","error":"PagerWarning__error--ew"};